
import { Component, Prop, Vue, Watch, Emit, Mixins } from 'vue-property-decorator';

@Component
export default class Navigation extends Vue {
    @Prop({ default: false }) value: boolean;
 
}
